import React from 'react';
import PropTypes from 'prop-types';
import InputTip from 'components/InputTip'

const propTypes = {};

export default function MergetagInputTip({ children: input, ...props }) {
  return <InputTip {...props} tip={<span>
    Use this input to type a custom mergetags.
    Enter word characters between curly brackets to create them.
    Examples: {'{size}, {is_true}, {term}'}
  </span>}>
    {input}
  </InputTip>
}

MergetagInputTip.propTypes = propTypes
MergetagInputTip.defaultProps = {}